import { Modal } from "components/modal";
import { Button } from "components/button";
import { Input } from "components/form/input";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useExtendAssessmentDeadline } from "hooks";

interface ExtendDeadlineModalProps {
  show: boolean;
  onClose: () => void;
  assessmentId: string;
  assessmentTitle: string;
  onSuccess?: () => void;
}

const deadlineSchema = Yup.object().shape({
  endDate: Yup.string().required("End date is required"),
  endTime: Yup.string().required("End time is required"),
});

const ExtendDeadlineModalTwo: React.FC<ExtendDeadlineModalProps> = ({
  show,
  onClose,
  assessmentId,
  assessmentTitle,
  onSuccess,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(deadlineSchema),
    mode: "onBlur",
  });

  const { extendDeadline, isLoading } = useExtendAssessmentDeadline();

  const onSubmit = (data: any) => {
    // Combine date and time into ISO 8601 format
    const dateTime = new Date(`${data.endDate}T${data.endTime}`);
    const isoString = dateTime.toISOString();

    extendDeadline(
      {
        assessmentId,
        endDate: isoString,
      },
      {
        onSuccess: () => {
          reset();
          onClose();
          onSuccess?.();
        },
      }
    );
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <Modal show={show} close={handleClose} contentClassName="w-[90%] max-w-[500px] p-0 rounded-lg">
      <div className="sm:p-8 py-3 px-2">
        <h2 className="sm:text-2xl text-xl font-semibold text-[#012169] mb-2">Extend Assessment Deadline</h2>
        <p className="text-sm text-[#667085] sm:mb-6 mb-3">{assessmentTitle}</p>

        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-5">
          <div className="flex flex-col gap-1">
            <Input
              label="New End Date"
              type="date"
              placeholder="Select end date"
              name="endDate"
              register={register}
              validatorMessage={errors.endDate?.message}
              className="w-full"
              parentClassName="!mb-0"
            />
          </div>

          <div className="flex flex-col gap-1">
            <Input
              label="End Time"
              type="time"
              placeholder="Select end time"
              name="endTime"
              register={register}
              validatorMessage={errors.endTime?.message}
              className="w-full"
              parentClassName="!mb-0"
            />
          </div>

          <div className="flex gap-3 mt-2">
            <Button
              type="transparent"
              onClick={handleClose}
              className="flex-1 h-11 !text-[13px] sm:!text-base !bg-white hover:!bg-[#F9FAFB] !border-[#012169] !text-[#012169]"
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              type="fill"
              onClick={handleSubmit(onSubmit)}
              className="flex-1 h-11 !text-[13px] sm:!text-base !bg-[#012169] hover:!bg-[#012169]/90 disabled:!bg-[#012169]/50 !border-none !text-white"
              disabled={isLoading}
            >
              {isLoading ? "Extending..." : "Extend Deadline"}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export { ExtendDeadlineModalTwo };
